module.exports = __webpack_public_path__ + "static/media/21ECLAC5.c71d82d4.jpg";